import React from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../shadcn/components/ui/button";

interface CancelledEventModelProps {
  setOpenCancelledEventModal: any;
  openCancelledEventModal: any;
}

export default function CancelledEventModel({
  openCancelledEventModal,
  setOpenCancelledEventModal,
}: CancelledEventModelProps) {
  return (
    <CustomModalLayout
      open={openCancelledEventModal}
      onClose={() => setOpenCancelledEventModal(false)}
      childrenClassName="px-4 lg:px-24 py-8 lg:py-10"
      className="pt-4 lg:pb-[30px] w-full mx-4 max-w-[650px]"
    >
      <div className="flex justify-center px-4 ">
        <div className="text-xs lg:text-sm font-openSans text-brand-textBlack max-w-[450px] flex flex-col justify-center items-center text-center gap-4 lg:gap-y-6">
          {/* <div>
          The scheduled event was cancelled by bank, due to a stay order
          issued by court.
        </div>
        <div> We apologize for the inconvenience.</div> */}
          <div className="text-xl">Auction cancelled by the Bank</div>
          <div className="text-sm font-semibold">
            The Auction has been cancelled by the bank due to following reason{" "}
          </div>
          <div className="">{openCancelledEventModal?.cancellation_reason}</div>
          <div className="max-w-[360px]">
            {" "}
            We apologize for the inconvenience. Reach out to AO for more details{" "}
          </div>
          <Button
            className="px-20"
            onClick={() => {
              setOpenCancelledEventModal(false);
            }}
          >
            Got it
          </Button>
        </div>
      </div>
    </CustomModalLayout>
  );
}
